import * as React from 'react';
import {connect} from 'react-redux';

import {Sidebar} from 'shells/sidebar/sidebar';

import type {ActiveItem} from '../../../types';
import {clearActiveItem} from '../../../ui-actions';
import {getActiveItem, getIsSidebarFormSaving} from '../../../ui-selectors';

import type {NutshellState} from '../../../../../store';

type OwnProps = {
    title: string;
    subtitle?: string;
    onSave?: () => any;
    closeButton?: boolean;
    saveText?: string;
    children: React.ReactNode;
};

type StateProps = {
    activeItem: ActiveItem | null | undefined;
    isSidebarFormSaving: boolean;
};

type DispatchProps = {
    closeSidebar: () => void;
};

type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        activeItem: getActiveItem(state),
        isSidebarFormSaving: getIsSidebarFormSaving(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        closeSidebar: () => {
            dispatch(clearActiveItem());
        },
    };
}

function SalesAutomationEditorComponent(props: Props) {
    const isNewItem = !props.activeItem || !props.activeItem.entityId;
    const defaultSaveText = isNewItem ? 'Add' : 'Save';

    return (
        <Sidebar
            isOpen={true}
            headerTitle={props.title}
            subtitle={props.subtitle}
            preventBodyScroll={false}
            canClickOutsideToClose={false}
            canEscapeToClose={true}
            onClose={props.closeSidebar}
            onSave={props.onSave ? props.onSave : props.closeSidebar}
            isSaving={props.isSidebarFormSaving}
            saveText={props.saveText ? props.saveText : defaultSaveText}
            closeButton={props.closeButton}
        >
            {props.children}
        </Sidebar>
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const SalesAutomationEditorSidebar = connector(SalesAutomationEditorComponent);
